import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {useIntl} from 'react-intl';
import {PageDeprecated} from './page-deprecated/PageDeprecated';
import {PageHeader} from 'web-components';

import GenericTooltip from '../../tooltips/generic_tooltip';
import OnboardingComponent from '../onboarding/onboarding_component';
import InputTitle from '../title/input_title';
import {Link} from 'react-router-dom';
import {CSS_CONSTANTS} from '../../../../../css_variables';
import {FeedbackButton} from '../../buttons/feedback-button';

const TYPE = {
	INPUT_REPORT_TITLE: 'input_report_title',
	ONBOARDING: 'onboarding',
	BETA: 'beta',
	FEEDBACK: 'feedback',
	PPR_DEPRECATION: 'ppr_deprecation',
	DEPRECATED_PAGE: 'deprecated_page',
	BACK_BUTTON: 'back_button',
};

export const TopHeaderBarWrapper = Styled.div`
    width: 100%;
    padding: ${({sidePadding = 24, bottomPadding = 0}) => `16px ${sidePadding}px ${bottomPadding}px`};
`;
export const TopHeaderBar = ({title, content = []}) => {
	const intl = useIntl();
	const POSITION = {
		LEFT: 'left',
	};

	const getSortOrder = type => {
		switch (type) {
			case TYPE.INPUT_REPORT_TITLE:
				return {position: POSITION.LEFT, order: 1};
			case TYPE.ONBOARDING:
				return {position: POSITION.LEFT, order: 2};
			case TYPE.BETA:
				return {position: POSITION.LEFT, order: 3};
			case TYPE.FEEDBACK:
				return {position: POSITION.LEFT, order: 4};
			case TYPE.BACK_BUTTON:
				return {position: POSITION.LEFT, order: 5};
			case TYPE.PPR_DEPRECATION:
				return {position: POSITION.RIGHT, order: 1};
			case TYPE.DEPRECATED_PAGE:
				return {position: POSITION.RIGHT, order: 2};
			default:
				return {position: POSITION.LEFT, order: -1};
		}
	};

	// SORTING HERE
	const sortedLeftContent = useMemo(() => {
		return content.filter(element => getSortOrder(element.type).position === POSITION.LEFT).sort((element1, element2) => (getSortOrder(element1.type).order < getSortOrder(element2.type).order ? -1 : 1));
	});
	const sortedRightContent = useMemo(() => {
		return content.filter(element => getSortOrder(element.type).position === POSITION.RIGHT).sort((element1, element2) => (getSortOrder(element1.type).order < getSortOrder(element2.type).order ? -1 : 1));
	});

	const constructElement = (element, index) => {
		switch (element.type) {
			case TYPE.INPUT_REPORT_TITLE:
				return (
					<InputTitle
						key={`input-report-title-${index}`}
						userpilot={element.userpilot}
						intl={element.intl}
						defaultTitle={element.defaultTitle}
						width={element.width}
						value={element.value}
						onChange={element.onChange}
						placeholder={element.placeholder}
					/>
				);
			case TYPE.ONBOARDING:
				return (
					<OnboardingComponent
						key={`onboarding-component-${index}`}
						intl={intl}
						positionLeft
						title={element.title}
						options={element.options}
						helpCenterLink={element.helpCenterLink}
						noSubtitle={element.noSubtitle}
						noHelpCenter={element.noHelpCenter}
						thirdLevelOnboardingContainer
					></OnboardingComponent>
				);
			case TYPE.BETA:
				return <GenericTooltip type="beta" key={'beta-tooltip' + index} />;

			case TYPE.FEEDBACK:
				return (
					<FeedbackButton
						key={'feedback-button' + index}
						link={
							element.link
								? element.link
								: 'https://experience.forecast.it/feedback?email=' + encodeURIComponent(element.userEmail)
						}
					/>
				);

			case TYPE.PPR_DEPRECATION:
				return (
					<PPRDeprecation>
						{intl.formatMessage(
							{
								id: 'financial_portfolio_report.deprecationMessage',
							},
							{
								a: chunks => <Link to="/insights/new/step1">{chunks}</Link>,
							}
						)}
					</PPRDeprecation>
				);

			case TYPE.DEPRECATED_PAGE:
				return <PageDeprecated text={element.text} link={element.link} />;
			case TYPE.BACK_BUTTON:
				return <div className="back-button" onClick={element.history.goBack} />;
			default:
				return element;
		}
	};

	return (
		<HeaderBarStyle>
			{title ? (
				<HeaderContainer>
					<div>
						<PageHeader key="title">{title}</PageHeader>
					</div>
				</HeaderContainer>
			) : null}
			{sortedLeftContent.map((element, index) => constructElement(element, index))}
			{sortedRightContent.length > 0 && <TopHeaderRightContent>{sortedRightContent.map((element, index) => constructElement(element, index))}</TopHeaderRightContent>}
		</HeaderBarStyle>
	);
};

TopHeaderBar.TYPE = TYPE;

TopHeaderBar.propTypes = {
	title: PropTypes.string,
	content: PropTypes.array,
};

const HeaderContainer = Styled.div`
	min-height:30px;
    margin-right: 24px;
    display: flex;
    align-items: center;
`;

const HeaderBarStyle = Styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    > * {
			margin-right: 14px;
        }
    .custom-button-container {
        height: 30px;
    }

    .beta-button {
        height: 30px;
        margin-right: 0px;
    }
    
`;

const TopHeaderRightContent = Styled.div`
	justify-content: flex-end;
	flex-grow: 1;
	display: flex;
`;

const PPRDeprecation = Styled.div`
	font-size: 13px;
	color: ${CSS_CONSTANTS.v2_text_gray};
	font-weight: 500;

	a:hover {
		color: ${CSS_CONSTANTS.v2_text_gray};
	}
`;
